










import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class ListSelector extends Vue {
  @Prop() private dataList!: any[];
  @Prop() private labelField!: string;

  // Methods
  private listElementSelected(element: any) {
    this.$emit('element-selected', element);
  }

  private itemTitle(element: any) {
    const levels = this.labelField.split( '.' );

    let titelItem = element;

    levels.forEach( (level) => {
      titelItem = titelItem[level];
    });

    return titelItem;
  }
}
